<template>
  <v-tab  @click="$emit('click')" :ripple="false" class="tab">
      <v-icon v-if="icon" class="pr-1" small >{{icon}}</v-icon>
      <slot/>
  </v-tab>
</template>

<script>
export default {
  name: "AppTab",
    emits: ['click'],
    props: {
      icon: {
          type: String
      }
    },
    methods: {
        doSomething() {
            // alert('I did something')
        }
    }
}
</script>

<style>
.tab {
    font-size: 14px;
    font-weight: 400;
    border-top-right-radius: 5px;
    border-top-left-radius: 5px;
    overflow: hidden;
    padding: 4px 8px;
}

.v-tab:hover {
    background-color: transparent;
}

.v-tab {
    text-transform: none!important;
    color: #9e9e9e!important;
}

.v-tab .v-icon {
    color: #9e9e9e;
}

.v-tab--selected {
    color: #333!important;
    font-weight: 600;
}

.v-tab--selected .v-icon {
    color: #333!important;
}
</style>
